export interface IAppSettings {
    id: number;
    snapshotFetched?: string;
    lastEventFetched?: string;
    lastEventId?: number;
    firstStart: boolean;

    lastSync?: string;
    lastSyncMessage?: string;

    /**
     * This is only for develop mode,
     * otherwise it should always be true
     */
    autoSync: boolean;

    /**
     * This is needed for offline mode
     * to not run into issues with auth
     */
    lastLoggedInUserId?: string;

    /**
     * Save datasetId temporary when using a direct link
     * to a dataset to be able to open it after user
     * is logged in and/or all data is loaded
     */
    directOpenId?: string ;

    /**
     * Due to an doubled identifier we need to check if
     * update was already applied.
     * See also: https://appsfactory.atlassian.net/browse/TTDB-874
     */
    tBlenMatrialUuidChanged?: boolean;
}

export class AppSettings implements AppSettings {
    public id: number;
    public snapshotFetched?: string;
    public lastEventFetched?: string;
    public lastEventId?: number;
    public firstStart: boolean;

    public lastSync?: string;
    public lastSyncMessage?: string;

    public autoSync: boolean;

    public lastLoggedInUserId?: string;

    public directOpenId?: string;

    public tBlenMatrialUuidChanged?: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IAppSettings);
    constructor(obj?: any) {
        // id should allways stay 1 since we only want one app settings
        this.id = 1;
        this.lastEventFetched = obj && obj.lastEventFetched || undefined;
        this.lastEventId = obj && obj.lastEventId != null ? obj.lastEventId : undefined;
        this.snapshotFetched = obj && obj.snapshotFetched || undefined;
        this.firstStart = obj && obj.firstStart || true;

        this.lastSync = obj && obj.lastSync || undefined;
        this.lastSyncMessage = obj && obj.lastSyncMessage || undefined;

        this.autoSync = obj && obj.autoSync || true;

        this.lastLoggedInUserId = obj && obj.lastLoggedInUserId || undefined;

        this.directOpenId = obj && obj.directOpenId || undefined;

        this.tBlenMatrialUuidChanged = obj && obj.tBlenMatrialUuidChanged || false;
    }
}
